import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { clas: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row mb-4" }, [
      _createElementVNode("div", { class: "col" }, [
        _createElementVNode("h1", null, "Dev tools")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("label", {
              for: "json-input",
              class: "form-label"
            }, "Json Object", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jsonText) = $event)),
              class: "form-control",
              rows: "10",
              id: "json-input"
            }, "            ", 512), [
              [_vModelText, _ctx.jsonText]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateUsers())),
              class: "btn btn-primary"
            }, " Run function ")
          ])
        ], 32)
      ])
    ])
  ]))
}